import { Instance } from 'mobx-state-tree';
import { SmsTemplateDtoModelBase } from './SmsTemplateDtoModel.base';
import getAppRoot from '../utils/getAppRoot';
import { enrichTemplateWithOrganizationData } from '../../../helpers/customerNotificationEvents';

/* The TypeScript type of an instance of SmsTemplateDtoModel */
export interface SmsTemplateDtoModelType extends Instance<typeof SmsTemplateDtoModel.Type> {}

/* A graphql query fragment builders for SmsTemplateDtoModel */
export { selectFromSmsTemplateDto, smsTemplateDtoModelPrimitives, SmsTemplateDtoModelSelector } from './SmsTemplateDtoModel.base';

/**
 * SmsTemplateDtoModel
 */
export const SmsTemplateDtoModel = SmsTemplateDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }))
  .views(self => ({
    parsedBody() {
      if (self.body && getAppRoot(self).organization?.name) {
        return enrichTemplateWithOrganizationData(self.body, getAppRoot(self).organization.name as string);
      }

      return self.body;
    },
  }));
